import * as React from 'react';
import { Radio, SelectionStatus } from '@symphony-ui/uitoolkit-components';
import SwapBenchmark from '../../../../../../models/data/SwapBenchmark';
const SwapBenchmarkEditor = ({ value = new SwapBenchmark({ side: 'MID' }), onChange }) => {
    const [side, setSide] = React.useState(value.side ?? 'MID');
    const set = React.useCallback((newValue) => {
        onChange({ target: { value: newValue } });
    }, [onChange]);
    const onChangeSide = React.useCallback((event) => {
        const target = event.target;
        const newValue = target.name;
        setSide(newValue);
        set(new SwapBenchmark({ side: newValue }));
    }, [set]);
    return (React.createElement("div", { style: { display: 'flex', marginTop: '0.5rem' } },
        React.createElement(Radio, { label: "MS", name: 'MID', onChange: onChangeSide, status: side === 'MID' ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, value: side }),
        React.createElement(Radio, { label: "ASW", name: 'ASW', onChange: onChangeSide, status: side === 'ASW' ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, value: side })));
};
export default SwapBenchmarkEditor;
